import React, { Fragment, useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Modal,
  FormControl,
  InputGroup,
  Tooltip,
  Overlay,
} from "react-bootstrap";
import { ArrowReturnLeft, Trash, Eraser } from "react-bootstrap-icons";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getGymExclusionDate } from "../redux/actions/gymActions";
import { fetchWorkshops, fetchGroups } from "../redux/actions/productActions";
import {
  updateCart,
  onlineCheckout,
  verifyCoupon,
  clearCoupon,
} from "../redux/actions/orderActions";
import { Controller, useForm } from "react-hook-form";
import Stepper from "bs-stepper";
import DatePicker from "react-datepicker";
import PhoneInput from "react-phone-input-2";
import BootstrapTable from "react-bootstrap-table-next";
import { BsPencil, BsTrash } from "react-icons/bs";
import {
  filter,
  find,
  findIndex,
  isEmpty,
  pullAt,
  range,
  reject,
  size,
} from "lodash";
import dayjs from "dayjs";
import dayjsRecur from "dayjs-recur";
import tz from "dayjs/plugin/timezone";
import PaymentForm from "../components/PaymentForm";
import Ipay88Form from "../components/Ipay88Form";
import WorkshopSidebar from "../components/WorkshopSidebar";
import {
  getWorkshop,
  getWorkshopVariants,
  getTicketPrice,
  getGroupsByVariants,
  getMinDays,
  getGroupsByAge,
  getAgeGrpDesc,
} from "../lib/product";
import config from "../config.json";

dayjs.extend(dayjsRecur);
dayjs.extend(tz);

const Workshops = () => {
  const dispatch = useDispatch();
  const tooltipRef = useRef(null);
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const dobRef = useRef(null);
  const genderRef = useRef(null);
  const mobileRef = useRef(null);
  const workshops = useSelector((state) => state.productData.workshops);
  const groups = useSelector((state) => state.productData.groups);
  const orders = useSelector((state) => state.orderData);
  const exclusionDate = useSelector((state) => state.gymData.excludeDates);
  const [stepper, setStepper] = useState();
  const [daysAhead, setDaysAhead] = useState(0);
  const [selectedTickets, setSelectedTickets] = useState({});
  const [registeredParticipants, setRegisteredParticipants] = useState([]);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showParticipantModal, setShowParticipantModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState({});
  const [participantMobile, setParticipantMobile] = useState({});
  const [participantError, setParticipantError] = useState("");
  const [workshop, setWorkshop] = useState([]);
  const [workshopVariants, setWorkshopVariants] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [minimumDate, setMinimumDate] = useState(
    dayjs().startOf("day").toDate()
  );
  const [customer, setCustomer] = useState({});
  const [cartCustomer, setCartCustomer] = useState({});
  const [couponCode, setCouponCode] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [couponError, setCouponError] = useState("");
  const [selectedWorkshop, setSelectedWorkshop] = useState("");

  let ticketCount = 0;
  let subTotal = 0;
  let ticketPrices = [];
  let normalPrices = [];

  const { payment } = orders;

  const { gym, cls } = useParams();
  const { pathname } = useLocation();
  const path = pathname.split("/")[1];
  const urlParams = new URLSearchParams(window.location.search);
  const orderId = urlParams.get("order_id");

  const actionButton = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Fragment>
        <span
          className="table-button"
          onClick={() => handleSelectedAction("edit", row)}
        >
          <BsPencil />
        </span>
        <span
          className="table-button"
          onClick={() => handleSelectedAction("delete", row)}
        >
          <BsTrash />
        </span>
      </Fragment>
    );
  };

  const participantsTableColumns = [
    {
      dataField: "id",
      text: "Id",
      hidden: true,
    },
    {
      dataField: "sku",
      text: "Sku",
      hidden: true,
    },
    {
      dataField: "type",
      text: "Workshop",
      sort: true,
      formatter: (cell, row) => {
        const visitDateFormatted = dayjs(row.visit_date).format("DD MMMM YYYY");
        return (
          <>
            <div>{cell}</div>
            <div>
              <strong>{visitDateFormatted}</strong>
            </div>
          </>
        );
      },
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      style: () => {
        return { wordWrap: "break-word" };
      },
    },
    {
      dataField: "email",
      text: "Email",
      style: () => {
        return { wordWrap: "break-word" };
      },
    },
    {
      dataField: "dob",
      text: "Birth Date",
    },
    {
      dataField: "mobile",
      text: "Phone No",
      style: () => {
        return { wordWrap: "break-word" };
      },
    },
    {
      dataField: "country_code",
      text: "Country Code",
      hidden: true,
    },
    {
      dataField: "number_only",
      text: "Number Only",
      hidden: true,
    },
    {
      dataField: "gender",
      text: "Gender",
      sort: true,
    },
    {
      dataField: "action",
      text: "",
      formatter: actionButton,
      headerStyle: () => {
        return { width: "10%" };
      },
      style: () => {
        return { padding: "12px 0px" };
      },
    },
  ];

  const {
    handleSubmit: handleSubmitTickets,
    getValues,
    setValue: setTicketsValue,
    clearErrors,
    watch: watchTickets,
    errors: errorsTickets,
    control: controlTickets,
  } = useForm({
    mode: "onChange",
  });

  const visitDate = watchTickets("visitdate");

  const {
    handleSubmit: handleSubmitParticipants,
    watch: watchParticipants,
    errors: errorsParticipants,
    control: controlParticipants,
    trigger: triggerParticipants,
    setValue: setValueParticipants,
  } = useForm({
    mode: "onChange",
  });

  const participantDob = watchParticipants("participantsdob");

  const handleDeleteParticipant = (confirm) => {
    if (confirm) {
      setRegisteredParticipants(
        reject(registeredParticipants, ["id", selectedParticipant.delete.id])
      );

      const count = getValues(selectedParticipant.delete.sku);
      setTicketsValue(selectedParticipant.delete.sku, +count - 1, {
        shouldValidate: true,
      });

      setSelectedTickets({
        ...selectedTickets,
        [selectedParticipant.delete.sku]: +count - 1,
      });
    }

    setSelectedParticipant({});
    setShowDeleteModal(false);
  };

  const handleSelectedAction = (action, selectedRow) => {
    let participantObject = {};
    participantObject[action] = find(registeredParticipants, [
      "id",
      selectedRow.id,
    ]);
    setSelectedParticipant(participantObject);
  };

  const validateTicketCount = () => {
    const data = getValues();
    let ticketCount = 0;

    if (data) {
      ticketCount = Object.keys(data)
        .filter((key) => key !== "visitdate" && data[key])
        .map((key) => parseInt(data[key]))
        .filter((value) => !isNaN(value))
        .reduce((sum, value) => sum + value, 0);
    }

    return ticketCount > 0;
  };

  const onSubmitTickets = (data) => {
    if (data) {
      let participantData = [];

      if (registeredParticipants && registeredParticipants.length > 0) {
        registeredParticipants.forEach((registeredParticipant) => {
          let participant = {
            type: registeredParticipant.type,
            sku: registeredParticipant.sku,
            name: registeredParticipant.name,
            email: registeredParticipant.email,
            dob: dayjs(registeredParticipant.dob).startOf("day").toDate(),
            gender: registeredParticipant.gender,
            phone: {
              country_code: registeredParticipant.country_code,
              number: registeredParticipant.number_only,
            },
            visit_date: dayjs(registeredParticipant.visit_date).format(
              "YYYY-MM-DD"
            ),
          };

          participantData.push(participant);
        });
      }

      let items = [];
      for (let key in data) {
        if (parseInt(data[key])) {
          let variant = find(workshopVariants, ["sku", key]);
          let ticketPrice = find(ticketPrices, (o) => {
            return o[key];
          });
          let normalPrice = find(normalPrices, (o) => {
            return o[key];
          });

          range(parseInt(data[key])).forEach(() => {
            let participantIndex = findIndex(participantData, [
              "sku",
              variant.sku,
            ]);

            if (variant) {
              const parentWorkshop = find(workshops, (ws) => {
                return ws.variants.includes(variant);
              });

              const participantEntry = pullAt(participantData, [
                participantIndex,
              ])?.[0];

              items.push({
                ...variant,
                quantity: 1,
                type: "WORKSHOP",
                name: parentWorkshop?._id + " " + variant.group,
                price: isEmpty(ticketPrice) ? null : ticketPrice[key],
                normalPrice: isEmpty(normalPrice) ? null : normalPrice[key],
                participant: participantEntry,
                visit_date: participantEntry?.visit_date,
              });
            }
          });
        }
      }
      dispatch(updateCart(items, ticketCount, subTotal));
      stepper.next();
    }
  };

  const onSubmitParticipants = (data) => {
    if (data) {
      const workshopGroups = getGroupsByVariants(workshopVariants, groups);
      const age = dayjs()
        .startOf("day")
        .diff(dayjs(data.participantsdob).startOf("day"), "year");

      const selectedWorkshopId = getValues("typeofworkshop");

      if (!selectedWorkshopId) {
        setParticipantError("Please select a workshop.");
        return;
      }

      const filteredVariants = workshopVariants.filter((variant) =>
        workshops
          .find((ws) => ws._id === selectedWorkshopId)
          ?.variants.includes(variant)
      );

      const matchedGroup = getGroupsByAge(filteredVariants, age)?.[0];

      if (!matchedGroup) {
        setParticipantError(
          "No variant matches the participant's age for this workshop."
        );
        return;
      }

      const matchedWorkshop = workshops.find((w) =>
        w.variants?.some((variant) => variant.sku === matchedGroup.sku)
      );
      const workshopType = matchedWorkshop?._id || matchedGroup.group;
      const workshopDesc = getAgeGrpDesc(matchedGroup);
      const workshopSku = matchedGroup.sku;

      const participantObject = {
        id: Date.now(),
        type: workshopType,
        sku: workshopSku,
        name: data.participantsname,
        email: data.participantsemail,
        dob: dayjs(data.participantsdob).startOf("day").format("DD MMMM YYYY"),
        gender: data.participantsgender,
        mobile: data.participantsmobile,
        country_code: participantMobile.country_code,
        number_only: participantMobile.number,
        visit_date: dayjs(data.visitdate).startOf("day").toDate(),
      };

      if (!isEmpty(selectedParticipant)) {
        const index = findIndex(registeredParticipants, [
          "id",
          selectedParticipant.edit.id,
        ]);
        registeredParticipants[index] = {
          ...participantObject,
          id: selectedParticipant.edit.id,
        };
        setRegisteredParticipants([...registeredParticipants]);
      } else {
        setRegisteredParticipants([
          ...registeredParticipants,
          participantObject,
        ]);
      }

      setSelectedParticipant({});
      setShowParticipantModal(false);
    }
  };

  const getCustomer = (customer) => {
    setCustomer(customer);
  };

  const handleCancelUpdate = () => {
    setSelectedParticipant({});
    setShowParticipantModal(false);
  };

  const handleAddWorkshop = () => {
    setSelectedParticipant({});
    setTicketsValue("typeofworkshop", "");
    setSelectedWorkshop("");
    setValueParticipants("visitdate", null);
    setValueParticipants("participantsname", "");
    setValueParticipants("participantsemail", "");
    setValueParticipants("participantsdob", null);
    setValueParticipants("participantsgender", "");
    setValueParticipants("participantsmobile", "");
    setShowParticipantModal(true);
  };

  const handleChangeTickets = (e) => {
    setSelectedTickets({
      ...selectedTickets,
      [e.target.name]: e.target.value,
    });
  };

  const handleCouponCode = () => {
    if (couponCode.length === 0) return;

    if (couponError.length > 0) {
      setCouponCode("");
      return;
    }

    if (couponDiscount > 0) {
      dispatch(clearCoupon());
    } else dispatch(verifyCoupon({ code: couponCode, cart: orders.cart }));
  };

  const handleBack = () => {
    dispatch(clearCoupon());
    stepper.previous();
  };

  const handleChangeParticipantMobile = (value, data) => {
    setParticipantMobile({
      country_code: data.dialCode,
      number: value.toString().replace(data.dialCode, ""),
    });
  };

  const isEvent = (date) => {
    let match = false;
    const workshopsToCheck = selectedWorkshop
      ? workshop.filter((ws) => ws._id === selectedWorkshop)
      : workshop;

    workshopsToCheck &&
      workshopsToCheck.length > 0 &&
      workshopsToCheck.some((ws) => {
        return (
          ws.event &&
          ws.event.length > 0 &&
          ws.event.some((event) => {
            if (event.repeat) {
              const interval = dayjs(event.start)
                .tz("Asia/Kuala_Lumpur")
                .recur()
                .every(
                  event.repeat.interval,
                  event.repeat.recurring.toLowerCase()
                );
              match = interval.matches(date);
              return match;
            } else {
              match = dayjs(date).isSame(event.start, "day");
              return match;
            }
          })
        );
      });
    return match;
  };

  useEffect(() => {
    dispatch(fetchWorkshops());
    dispatch(fetchGroups());
    dispatch(getGymExclusionDate(gym.replace(/-/g, " ")));
  }, [gym, dispatch]);

  useEffect(() => {
    setWorkshop(
      getWorkshop(workshops, path, cls, gym.replace(/-/g, " ").toLowerCase())
    );
  }, [workshops, path, cls, gym]);

  useEffect(() => {
    setWorkshopVariants(getWorkshopVariants(workshop));
  }, [workshop]);

  useEffect(() => {
    const days = getMinDays(workshopVariants);

    setMinimumDate(dayjs().add(days, "day").startOf("day").toDate());
  }, [workshopVariants]);

  useEffect(() => {
    setStepper(
      new Stepper(document.querySelector(".bs-stepper"), { animation: true })
    );
  }, []);

  useEffect(() => {
    if (visitDate) {
      setDaysAhead(
        dayjs(visitDate).startOf("day").diff(dayjs().startOf("day"), "day")
      );
    }
  }, [visitDate]);

  useEffect(() => {
    if (selectedWorkshop === "Introduction to Lead Belaying and Climbing") {
      setMinimumDate(dayjs().add(3, "day").toDate());
    } else {
      setMinimumDate(dayjs().toDate());
    }
  }, [selectedWorkshop]);

  useEffect(() => {
    if (!isEmpty(selectedParticipant)) {
      if (Object.keys(selectedParticipant).includes("edit")) {
        setShowParticipantModal(true);
      } else if (Object.keys(selectedParticipant).includes("delete")) {
        setShowDeleteModal(true);
      }
    }
  }, [selectedParticipant]);

  const selectedWS = workshop.find((w) => w._id === selectedWorkshop);
  const isSingleDate =
    selectedWS?.event?.length === 1 && !selectedWS.event[0].repeat;

  useEffect(() => {
    if (
      showParticipantModal &&
      workshop.length === 1 &&
      !selectedWorkshop &&
      isEmpty(selectedParticipant)
    ) {
      const singleWS = workshop[0];
      setTicketsValue("typeofworkshop", singleWS._id);
      setSelectedWorkshop(singleWS._id);

      if (singleWS.event?.length === 1 && !singleWS.event[0].repeat) {
        setValueParticipants(
          "visitdate",
          dayjs(singleWS.event[0].start).toDate()
        );
      }
    }
  }, [
    showParticipantModal,
    workshop,
    selectedWorkshop,
    setTicketsValue,
    setValueParticipants,
  ]);

  useEffect(() => {
    if (registeredParticipants.length > 0) {
      let tickets = {};
      const workshopGroups = getGroupsByVariants(workshopVariants, groups);

      workshopGroups &&
        workshopGroups.forEach((workshopGroup) => {
          let count = 0;
          count = filter(registeredParticipants, (participant) => {
            return participant.sku === workshopGroup.sku;
          }).length;

          tickets[workshopGroup.sku] = count;
          setTicketsValue(workshopGroup.sku, count.toString(), {
            shouldValidate: !isEmpty(errorsTickets),
          });
        });

      setSelectedTickets(tickets);
    }
  }, [
    registeredParticipants,
    errorsTickets,
    workshopVariants,
    setTicketsValue,
  ]);

  useEffect(() => {
    if (!isEmpty(customer)) dispatch(onlineCheckout(customer));
  }, [customer, dispatch]);

  useEffect(() => {
    if (orderId) {
      if (orders.cart.items && orders.cart.items.length > 0) {
        let selectTickets = {};
        let restoreParticipants = [];

        orders.cart.items.forEach((item) => {
          selectTickets[item.sku] = selectTickets[item.sku]
            ? (parseInt(selectTickets[item.sku]) + item.quantity).toString()
            : item.quantity.toString();

          if (item.participant) {
            restoreParticipants.push({
              id: Date.now(),
              type: item.participant.type,
              sku: item.participant.sku,
              name: item.participant.name,
              email: item.participant.email,
              dob: dayjs(item.participant.dob)
                .startOf("day")
                .format("DD MMMM YYYY"),
              gender: item.participant.gender,
              mobile:
                item.participant.phone.country_code +
                item.participant.phone.number,
              country_code: item.participant.phone.country_code,
              number_only: item.participant.phone.number,
              visit_date: dayjs(item.participant.visit_date)
                .startOf("day")
                .toDate(),
            });
          }
        });

        setSelectedTickets(selectTickets);

        if (restoreParticipants.length > 0)
          setRegisteredParticipants(restoreParticipants);
      }

      setCartCustomer(orders.cart.customer);
    }
  }, [orderId]);

  useEffect(() => {
    if (!couponCode || couponCode.length === 0) {
      dispatch(clearCoupon());
    }
  }, [couponCode]);

  useEffect(() => {
    const { coupon } = orders.cart;

    if (coupon) {
      let dataType = typeof coupon;
      if (dataType === "object") {
        if (coupon.total_discount > 0) {
          setCouponError("");
          setCouponDiscount(orders.cart.coupon.total_discount);
        } else {
          setCouponError("The code is not applicable to this order");
          setCouponDiscount(0);
        }
      } else if (dataType === "string") {
        setCouponError(orders.cart.coupon);
        setCouponDiscount(0);
      }
    } else {
      setCouponCode("");
      setCouponError("");
      setCouponDiscount(0);
    }
  }, [orders.cart.coupon]);

  useEffect(() => {
    setParticipantError("");
  }, [participantDob]);

  return (
    <Container fluid className="layout">
      <Row className="space-ptb-10">
        <Col lg={3} className="d-none d-lg-block">
          <WorkshopSidebar />
        </Col>
        <Col lg={9} md={12}>
          <div
            id="stepperForm"
            className="bs-stepper"
            style={showLoading ? { display: "none" } : {}}
          >
            <div className="bs-stepper-header" role="tablist">
              <div className="step" data-target="#workshops-form-1">
                <Button
                  className="step-trigger"
                  role="tab"
                  id="stepperFormTrigger1"
                  aria-controls="workshops-form-1"
                  disabled
                >
                  <span className="bs-stepper-circle">1</span>
                  <span className="bs-stepper-label">Buy Ticket(s)</span>
                </Button>
              </div>
              <div className="bs-stepper-line"></div>
              <div className="step" data-target="#workshops-form-2">
                <Button
                  className="step-trigger"
                  role="tab"
                  id="stepperFormTrigger2"
                  aria-controls="workshops-form-2"
                  disabled
                >
                  <span className="bs-stepper-circle">2</span>
                  <span className="bs-stepper-label">Order Summary</span>
                </Button>
              </div>
              <div className="bs-stepper-line"></div>
              <div className="step" data-target="#workshops-form-3">
                <Button
                  className="step-trigger"
                  role="tab"
                  id="stepperFormTrigger3"
                  aria-controls="workshops-form-3"
                  disabled
                >
                  <span className="bs-stepper-circle">3</span>
                  <span className="bs-stepper-label">Payment</span>
                </Button>
              </div>
            </div>

            <div className="bs-stepper-content">
              <div
                id="workshops-form-1"
                role="tabpanel"
                className="bs-stepper-pane fade"
                aria-labelledby="stepperFormTrigger1"
              >
                {workshop && workshop.length > 0 ? (
                  <form onSubmit={handleSubmitTickets(onSubmitTickets)}>
                    <Row className="form-body">
                      <BootstrapTable
                        className="participant-table"
                        keyField="id"
                        bootstrap4={true}
                        striped={true}
                        caption={"Register for workshop"}
                        data={registeredParticipants}
                        columns={participantsTableColumns}
                        selectRow={{
                          mode: "checkbox",
                          clickToSelect: true,
                          hideSelectColumn: true,
                        }}
                        noDataIndication={
                          "No registration. Minimum 1 registration."
                        }
                      />
                    </Row>
                    <Row className="center-button space-mb-30">
                      <Button
                        className="btn btn-primary mobile-size"
                        onClick={handleAddWorkshop}
                      >
                        Add Workshop
                      </Button>
                    </Row>

                    {workshop[0] && workshop[0].description && (
                      <Row className="space-mb-30">
                        <Col>
                          <div className="pass-description">
                            <p>{workshop[0].description}</p>
                          </div>
                        </Col>
                      </Row>
                    )}

                    <Row className="form-body">
                      <Table>
                        <thead>
                          <tr>
                            <th className="mobile-hide"></th>
                            <th className="align-middle">Types of Classes</th>
                            <th className="align-middle">Online Price (RM)</th>
                            <th className="align-middle">Quantity</th>
                            <th className="align-middle">Total (RM)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {workshopVariants.map((variant, i) => {
                            const oriPrice = getTicketPrice(variant.price, 0);
                            const ticketPrice = getTicketPrice(
                              variant.price,
                              daysAhead
                            );
                            const totalPrice = selectedTickets[variant.sku]
                              ? selectedTickets[variant.sku] * ticketPrice.value
                              : 0;

                            let opObj = {};
                            opObj[variant.sku] = oriPrice;
                            normalPrices.push(opObj);

                            let tpObj = {};
                            tpObj[variant.sku] = ticketPrice;
                            ticketPrices.push(tpObj);

                            subTotal += totalPrice;
                            return (
                              <tr key={i}>
                                <td className="mobile-hide align-middle">
                                  {(variant.photos && variant.photos.length > 0) ?
                                    (<img src={config.image.imageServerURL +
                                      variant.photos[0] +
                                      config.image.imageResizeTag +
                                      config.image.imageResizeProduct}
                                      alt={variant.group}
                                      onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.parentNode.innerHTML = variant.group;
                                      }}
                                    />) : (<div className="image-fallback">{variant.group}</div>)}
                                </td>
                                <td className="align-middle">{variant.desc}</td>
                                <td className="align-middle">
                                  {oriPrice.value > ticketPrice.value && (
                                    <Fragment>
                                      <span className="price-discount">
                                        {oriPrice.value.toFixed(2)}
                                      </span>{" "}
                                      <br className="mobile-only"></br>
                                    </Fragment>
                                  )}
                                  {ticketPrice.value.toFixed(2)}
                                </td>
                                <td className="align-middle">
                                  <Controller
                                    name={variant.sku}
                                    control={controlTickets}
                                    defaultValue={
                                      selectedTickets[variant.sku]
                                        ? selectedTickets[
                                          variant.sku
                                        ].toString()
                                        : ""
                                    }
                                    render={({ name, onChange, value }) => (
                                      <FormControl
                                        className={
                                          errorsTickets &&
                                            ((errorsTickets.visitdate &&
                                              size(errorsTickets) > 1) ||
                                              (!errorsTickets.visitdate &&
                                                size(errorsTickets) > 0))
                                            ? "validation quantity"
                                            : "quantity"
                                        }
                                        name={name}
                                        as="select"
                                        value={value}
                                        disabled
                                        onChange={(e) => {
                                          onChange(e.target.value);
                                          handleChangeTickets(e);
                                        }}
                                      >
                                        <option value=""></option>
                                        {range(
                                          variant.min_qty,
                                          variant.min_qty * 20
                                        ).map((i) => {
                                          return (
                                            <option
                                              value={i.toString()}
                                              key={i}
                                            >
                                              {i}
                                            </option>
                                          );
                                        })}
                                      </FormControl>
                                    )}
                                    rules={{ validate: validateTicketCount }}
                                  />
                                </td>
                                <td className="align-middle">
                                  {totalPrice.toFixed(2)}
                                </td>
                              </tr>
                            );
                          })}
                          <tr className="grey-panel">
                            <td className="mobile-hide"></td>
                            <td colSpan="3" className="text-right">
                              Subtotal (RM)
                            </td>
                            <td>{subTotal.toFixed(2)}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Row>
                    <Row className="row-space-20">
                      <Col className="space-pd-0 text-left">
                        <Button
                          className="btn btn-danger mobile-size"
                          onClick={() => setShowCancelModal(true)}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col className="space-pd-0 text-right">
                        <Button
                          className="btn btn-primary mobile-size"
                          type="submit"
                        >
                          Next
                        </Button>
                      </Col>
                    </Row>
                  </form>
                ) : (
                  <h3>No Workshop Found</h3>
                )}
              </div>
              <div
                id="workshops-form-2"
                role="tabpanel"
                className="bs-stepper-pane fade"
                aria-labelledby="stepperFormTrigger2"
              >
                {orders &&
                  orders.cart &&
                  orders.cart.items &&
                  orders.cart.items.length > 0 ? (
                  <Fragment>
                    <h4 className="row-space-20">
                      Summary of your order items
                    </h4>
                    <p className="mobile-only">
                      Visit Date:{" "}
                      {registeredParticipants.map((participant, index) => (
                        <span key={index}>
                          {dayjs(participant.visit_date)
                            .startOf("day")
                            .format("DD MMMM YYYY")}
                          {index < registeredParticipants.length - 1
                            ? ", "
                            : ""}
                        </span>
                      ))}
                    </p>
                    <Row>
                      <Table>
                        <thead>
                          <tr>
                            <th>Item(s)</th>
                            <th className="mobile-hide">Visit Date</th>
                            <th>Price (RM)</th>
                            <th>Quantity</th>
                            <th>Subtotal (RM)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orders.cart.items.map((item, i) => {
                            const oriPrice = getTicketPrice(
                              [item.normalPrice],
                              0
                            );
                            const ticketPrice = getTicketPrice(
                              [item.price],
                              daysAhead
                            );
                            const subTotalPrice =
                              item.quantity * ticketPrice.value;
                            return (
                              <tr key={i}>
                                <td>
                                  {item.desc}
                                  <div>
                                    <strong>{item.participant.name}</strong>
                                  </div>
                                </td>
                                <td className="mobile-hide">
                                  {dayjs(item.participant?.visit_date)
                                    .startOf("day")
                                    .format("DD MMMM YYYY")}
                                </td>
                                <td>
                                  {oriPrice.value > ticketPrice.value && (
                                    <Fragment>
                                      <span className="price-discount">
                                        {oriPrice.value.toFixed(2)}
                                      </span>{" "}
                                    </Fragment>
                                  )}
                                  {ticketPrice.value.toFixed(2)}
                                </td>
                                <td>{item.quantity}</td>
                                <td>{subTotalPrice.toFixed(2)}</td>
                              </tr>
                            );
                          })}
                          <tr className="text-bold">
                            <td className="mobile-hide"></td>
                            <td colSpan="2" className="text-right">
                              Ticket Amount
                            </td>
                            <td></td>
                            <td>{orders.cart.subtotal?.toFixed(2)}</td>
                          </tr>
                          <tr className="text-bold">
                            <td className="mobile-hide"></td>
                            <td
                              colSpan="2"
                              className="text-right"
                              style={{ verticalAlign: "middle" }}
                            >
                              {orders.cart.coupon && couponDiscount > 0
                                ? "Discount (" + orders.cart.coupon.code + ")"
                                : "Discount"}
                            </td>
                            <td colSpan="2">
                              {orders.cart.coupon && couponDiscount > 0 ? (
                                <div style={{ verticalAlign: "middle" }}>
                                  - {couponDiscount.toFixed(2)}{" "}
                                  <Trash
                                    size={18}
                                    style={{
                                      float: "right",
                                      cursor: "pointer",
                                    }}
                                    onClick={handleCouponCode}
                                  />
                                </div>
                              ) : (
                                <InputGroup size="sm">
                                  <FormControl
                                    ref={tooltipRef}
                                    placeholder="Coupon"
                                    aria-label="Coupon"
                                    aria-describedby="coupon-code"
                                    className="mobile-size"
                                    htmlSize="10"
                                    onChange={(e) =>
                                      setCouponCode(e.target.value)
                                    }
                                    value={couponCode}
                                    onKeyPress={(key) => {
                                      if (
                                        key.code === "Enter" ||
                                        key.code === "NumpadEnter"
                                      )
                                        handleCouponCode();
                                    }}
                                    disabled={couponDiscount > 0}
                                  />
                                  <Overlay
                                    target={tooltipRef}
                                    show={couponError.length > 0}
                                    placement="top"
                                  >
                                    {(props) => (
                                      <Tooltip id="mesg-tooltip" {...props}>
                                        {couponError}
                                      </Tooltip>
                                    )}
                                  </Overlay>
                                  <InputGroup.Append>
                                    <Button
                                      variant="outline-secondary"
                                      className="mobile-size"
                                      onClick={handleCouponCode}
                                    >
                                      {couponError.length > 0 ? (
                                        <Eraser />
                                      ) : (
                                        <ArrowReturnLeft />
                                      )}
                                    </Button>
                                  </InputGroup.Append>
                                </InputGroup>
                              )}
                            </td>
                          </tr>
                          <tr className="text-bold">
                            <td className="mobile-hide"></td>
                            <td colSpan="2" className="text-right">
                              TOTAL (RM)
                            </td>
                            <td></td>
                            <td>
                              {(orders.cart.subtotal - couponDiscount)?.toFixed(
                                2
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Row>
                    <Row className="row-space-20">
                      <Col className="space-pd-0 text-left">
                        <Button
                          className="btn btn-danger mobile-size"
                          onClick={() => setShowCancelModal(true)}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col className="space-pd-0 text-right">
                        <Button
                          className="btn btn-primary mobile-size"
                          onClick={handleBack}
                        >
                          Back
                        </Button>
                        <span> </span>
                        <Button
                          className="btn btn-primary mobile-size"
                          onClick={() => stepper.next()}
                        >
                          Buy Now
                        </Button>
                      </Col>
                    </Row>
                  </Fragment>
                ) : (
                  <h3>No order found</h3>
                )}
              </div>
              <div
                id="workshops-form-3"
                role="tabpanel"
                className="bs-stepper-pane fade"
                aria-labelledby="stepperFormTrigger3"
              >
                <PaymentForm
                  stepper={stepper}
                  customer={cartCustomer}
                  disableEmail={false}
                  getCustomer={getCustomer}
                  setShowCancelModal={setShowCancelModal}
                />
              </div>
            </div>
          </div>
          <Modal
            show={showCancelModal}
            onHide={() => setShowCancelModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Cancel Order ?</Modal.Title>
            </Modal.Header>
            <Modal.Body>Changes you made may not be saved.</Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowCancelModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => (window.location.href = `/workshop/${gym}`)}
              >
                Ok
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showParticipantModal}
            onHide={() => setShowParticipantModal(false)}
            centered
            backdrop="static"
          >
            <form onSubmit={handleSubmitParticipants(onSubmitParticipants)}>
              <Modal.Header closeButton>
                <Modal.Title>Workshop Registration Form</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className="space-mb-15">
                  <Col lg={3} md={12} className="space-pt-7 text-label">
                    <span className="form-label">Workshop:</span>
                  </Col>
                  <Col lg={9} md={12} className="text-left">
                    <Controller
                      name="typeofworkshop"
                      control={controlTickets}
                      defaultValue={
                        selectedParticipant?.edit
                          ? selectedParticipant.edit.type
                          : ""
                      }
                      rules={{ required: "This field is required" }}
                      render={({ onChange, value }) => (
                        <>
                          <FormControl
                            as="select"
                            value={value}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              onChange(selectedId);
                              setSelectedWorkshop(selectedId);
                              const selectedWS = workshop.find(
                                (w) => w._id === selectedId
                              );
                              if (
                                selectedWS?.event?.length === 1 &&
                                !selectedWS.event[0].repeat
                              ) {
                                setValueParticipants(
                                  "visitdate",
                                  dayjs(selectedWS.event[0].start).toDate()
                                );
                              }
                              triggerParticipants("visitdate");
                            }}
                            className={`form-select ${errorsTickets?.typeofworkshop ? "is-invalid" : ""
                              }`}
                            required
                          >
                            <option value="">Select a workshop</option>
                            {workshop.map((w) => (
                              <option key={w._id} value={w._id}>
                                {w._id}
                              </option>
                            ))}
                          </FormControl>
                        </>
                      )}
                    />
                  </Col>
                </Row>
                <Row className="space-mb-15">
                  <Col lg={3} md={12} className="space-pt-7 text-label">
                    <span className="form-label">Visit Date:</span>
                  </Col>
                  <Col lg={9} md={12} className="text-left">
                    <Controller
                      name="visitdate"
                      control={controlParticipants}
                      defaultValue={
                        selectedParticipant?.edit
                          ? dayjs(selectedParticipant.edit.visit_date).toDate()
                          : null
                      }
                      render={({ onChange, value }) => (
                        <DatePicker
                          className="form-control visit-date"
                          dateFormat="dd MMMM yyyy"
                          filterDate={isEvent}
                          selected={value}
                          onChange={(value) => {
                            onChange(value);
                            if (value) {
                              nameRef.current.focus();
                            }
                          }}
                          minDate={minimumDate}
                          excludeDates={
                            exclusionDate
                              ? exclusionDate.map((date) =>
                                dayjs(date).toDate()
                              )
                              : []
                          }
                        />
                      )}
                      rules={{
                        required: "This field is required",
                        validate: (value) => {
                          if (
                            selectedWorkshop ===
                            "Introduction to Lead Belaying and Climbing"
                          ) {
                            const minDate = dayjs().add(3, "days");
                            if (dayjs(value).isBefore(minDate, "day")) {
                              return "Visit date must be at least 3 days ahead for this workshop.";
                            }
                          }

                          if (selectedWorkshop && !isEvent(value)) {
                            return "The selected date is not available for this workshop.";
                          }

                          return true;
                        },
                      }}
                    />
                    {
                      <span className="error-text mobile-size">
                        {errorsParticipants && errorsParticipants.visitdate
                          ? errorsParticipants.visitdate.message
                          : ""}
                      </span>
                    }
                  </Col>
                </Row>
                <hr style={{ borderTop: "3px solid #ccc", margin: "20px 0" }} />
                <Row className="space-mb-15">
                  <Col lg={3} md={12} className="space-pt-7 text-label">
                    <span className="form-label">Name:</span>
                  </Col>
                  <Col lg={9} md={12} className="text-left">
                    <Controller
                      name="participantsname"
                      control={controlParticipants}
                      defaultValue={
                        !isEmpty(selectedParticipant) &&
                          selectedParticipant.edit
                          ? selectedParticipant.edit.name
                          : ""
                      }
                      render={({ onChange, value }) => (
                        <FormControl
                          ref={nameRef}
                          type="text"
                          defaultValue={value}
                          placeholder="Full name as per IC / Passport"
                          onChange={(e) => onChange(e.target.value)}
                          onKeyDown={async (e) => {
                            if (e.key === "Enter" && e.target.value) {
                              const isValid = await triggerParticipants(
                                "participantsname"
                              );
                              if (isValid) {
                                e.preventDefault();
                                emailRef.current.focus();
                              }
                            }
                          }}
                        />
                      )}
                      rules={{ required: "This field is required" }}
                    />
                    {
                      <span className="error-text mobile-size">
                        {errorsParticipants &&
                          errorsParticipants.participantsname
                          ? errorsParticipants.participantsname.message
                          : ""}
                      </span>
                    }
                  </Col>
                </Row>
                <Row className="space-mb-15">
                  <Col lg={3} md={12} className="space-pt-7 text-label">
                    <span className="form-label">Email:</span>
                  </Col>
                  <Col lg={9} md={12} className="text-left">
                    <Controller
                      name="participantsemail"
                      control={controlParticipants}
                      defaultValue={
                        !isEmpty(selectedParticipant) &&
                          selectedParticipant.edit
                          ? selectedParticipant.edit.email
                          : ""
                      }
                      render={({ onChange, value }) => (
                        <FormControl
                          ref={emailRef}
                          type="email"
                          defaultValue={value}
                          placeholder="example@email.com"
                          onChange={(e) => onChange(e.target.value)}
                          onKeyDown={async (e) => {
                            if (e.key === "Enter" && e.target.value) {
                              const isValid = await triggerParticipants(
                                "participantsemail"
                              );
                              if (isValid) {
                                e.preventDefault();
                                dobRef.current.setFocus();
                              }
                            }
                          }}
                        />
                      )}
                      rules={{ required: "This field is required" }}
                    />
                    {
                      <span className="error-text mobile-size">
                        {errorsParticipants &&
                          errorsParticipants.participantsemail
                          ? errorsParticipants.participantsemail.message
                          : ""}
                      </span>
                    }
                  </Col>
                </Row>
                <Row className="space-mb-15">
                  <Col lg={3} md={12} className="space-pt-7 text-label">
                    <span className="form-label">Birth Date:</span>
                  </Col>
                  <Col lg={9} md={12} className="text-left dob-box">
                    <Controller
                      name="participantsdob"
                      control={controlParticipants}
                      defaultValue={
                        !isEmpty(selectedParticipant) &&
                          selectedParticipant.edit
                          ? dayjs(selectedParticipant.edit.dob)
                            .startOf("day")
                            .toDate()
                          : null
                      }
                      render={({ onChange, value }) => (
                        <DatePicker
                          ref={dobRef}
                          className="form-control dob"
                          dateFormat="dd MMMM yyyy"
                          selected={value}
                          onChange={(value) => {
                            onChange(value);
                            if (value) {
                              genderRef.current.focus();
                            }
                          }}
                          maxDate={dayjs().startOf("day").toDate()}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                        />
                      )}
                      rules={{ required: "This field is required" }}
                    />
                    {
                      <span className="error-text mobile-size">
                        {errorsParticipants &&
                          errorsParticipants.participantsdob
                          ? errorsParticipants.participantsdob.message
                          : participantError}
                      </span>
                    }
                  </Col>
                </Row>
                <Row className="space-mb-15">
                  <Col lg={3} md={12} className="space-pt-7 text-label">
                    <span className="form-label">Gender:</span>
                  </Col>
                  <Col lg={9} md={12} className="text-left">
                    <Controller
                      name="participantsgender"
                      control={controlParticipants}
                      defaultValue={
                        !isEmpty(selectedParticipant) &&
                          selectedParticipant.edit
                          ? selectedParticipant.edit.gender
                          : ""
                      }
                      render={({ onChange, value }) => (
                        <FormControl
                          ref={genderRef}
                          as="select"
                          defaultValue={value}
                          onChange={(e) => onChange(e.target.value)}
                          onKeyDown={async (e) => {
                            if (e.key === "Enter" && e.target.value) {
                              const isValid = await triggerParticipants(
                                "participantsgender"
                              );
                              if (isValid) {
                                e.preventDefault();
                                if (mobileRef.current) {
                                  mobileRef.current.focus();
                                }
                              }
                            }
                          }}
                        >
                          <option value=""></option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </FormControl>
                      )}
                      rules={{ required: "This field is required" }}
                    />
                    {
                      <span className="error-text mobile-size">
                        {errorsParticipants &&
                          errorsParticipants.participantsgender
                          ? errorsParticipants.participantsgender.message
                          : ""}
                      </span>
                    }
                  </Col>
                </Row>
                <Row className="space-mb-15">
                  <Col lg={3} md={12} className="space-pt-7 text-label">
                    <span className="form-label">Mobile No:</span>
                  </Col>
                  <Col lg={9} md={12} className="text-left">
                    <Controller
                      name="participantsmobile"
                      control={controlParticipants}
                      defaultValue={
                        !isEmpty(selectedParticipant) &&
                          selectedParticipant.edit
                          ? selectedParticipant.edit.mobile
                          : ""
                      }
                      render={({ onChange, value }) => (
                        <PhoneInput
                          inputProps={{
                            ref: mobileRef,
                          }}
                          country="my"
                          value={value}
                          preferredCountries={["my"]}
                          enableSearch={true}
                          onChange={(value, data) => {
                            onChange(value);
                            handleChangeParticipantMobile(value, data);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && value) {
                              e.preventDefault();
                              handleSubmitParticipants(onSubmitParticipants)();
                            }
                          }}
                        />
                      )}
                      rules={{ required: "This field is required" }}
                    />
                    {
                      <span className="error-text mobile-size">
                        {errorsParticipants &&
                          errorsParticipants.participantsmobile
                          ? errorsParticipants.participantsmobile.message
                          : ""}
                      </span>
                    }
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outline-primary" type="submit">
                  Continue
                </Button>
                <Button variant="outline-primary" onClick={handleCancelUpdate}>
                  Cancel
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
          <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Delete Registration</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you confirm to delete registration?</Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => handleDeleteParticipant(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => handleDeleteParticipant(true)}
              >
                Ok
              </Button>
            </Modal.Footer>
          </Modal>

          {payment && !payment.error && (
            <Ipay88Form
              payment={payment}
              showLoading={showLoading}
              setShowLoading={setShowLoading}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Workshops;
